import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import React from 'react';
import {
  //useDispatch,
  useSelector,
} from 'react-redux';
import { getCurrentSalesChannel } from 'src/constrains/SalesChannelHOC/slice';
import {
  EnumMultiLanguageType,
  urlParamsKey,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import SiteStyleSelect from 'src/constrains/SalesChannelStyleSelect/WebSiteTypeSelect';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Left = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const salesChannel = useSelector(getCurrentSalesChannel());
  const { name } = salesChannel || {};
  const breadcrumbData = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/salesChannels',
      name: getI18n('general.sider.salesChannel'),
    },
    {
      url: '',
      name: name,
    },
    {
      url: '',
      name: getI18n('general.sider.maintenance'),
    },
  ];
  return (
    <Breadcrumb className={css.breadcrumb} breadcrumbData={breadcrumbData} />
  );
};

const Right = (props) => {
  const { hasModified, onDiscard, onSubmit, rarePart, onSaveDisable } = props;
  return (
    <TopRight
      extraLeft={
        <div style={{ marginRight: 8, display: 'flex' }}>
          <div style={{ marginRight: 16 }}>
            <SiteStyleSelect
              salesChannelUuidKey={'uuid'}
              customType={EnumMultiLanguageType.SalesChannelMaintenancePage}
              hasModified={hasModified}
            />
          </div>

          <MultiLangDropDown
            hasModified={hasModified}
            customType={EnumMultiLanguageType.SalesChannelMaintenancePage}
            salesChannelUuidKey={
              urlParamsKey[EnumMultiLanguageType.SalesChannelMaintenancePage]
            }
          />
        </div>
      }
      onDiscard={onDiscard}
      onSubmit={onSubmit}
      onSaveDisable={!hasModified || onSaveDisable}
      rarePart={rarePart}
    />
  );
};

const Header = (props) => {
  const { topRight } = props;
  return (
    <div className={css.topStickContainer}>
      <div className={css.topStickLeft}>
        <Left />
      </div>
      <div className={css.topStickRight}>{topRight}</div>
    </div>
  );
};
export { Right };
export default Header;
